import { UrlHelpers } from "@/shared/services/UrlHelpers";

export class FileSystemRecord {
    modificationDate: Date;
    createdDate: Date;
    undoDate: Date;
    blob: Blob | null;
    size: number;
    systemFileNumber: number;
    isFolder: boolean;
    addtionalMetadata: any;
    format?: string;

    /* ---------- runtime-only ---------- */
    
    _objectBlobUrl?: string;             // regenerated every page load


    /**
     *
     */
    constructor(
        blob: Blob | null,
        modificationDate: Date,
        createdDate: Date,
        undoDate: Date,
        size: number,
        systemFileNumber: number,
        isFolder: boolean,
        addtionalMetadata: any
    ) {
        this.blob = blob;
        this.size = size;
        this.modificationDate = modificationDate;
        this.createdDate = createdDate;
        this.undoDate = undoDate;
        this.isFolder = isFolder;
        this.systemFileNumber = systemFileNumber
        this.addtionalMetadata = addtionalMetadata
    }

    async getBase64Url(): Promise<string> {
        const arrayBuffer = await this.blob.arrayBuffer();
        const uint8Array = new Uint8Array(arrayBuffer);
        let binary = '';
        uint8Array.forEach(b => (binary += String.fromCharCode(b)));
        const base64 = typeof btoa === 'function' ? btoa(binary) : Buffer.from(binary, 'binary').toString('base64');
        const mime = this.blob.type || 'application/octet-stream';
        let base64Url = `data:${mime};base64,${base64}`;
        return base64Url;
    }

    async getBlobUrl(): Promise<string> {
        if (this._objectBlobUrl) {
            return this._objectBlobUrl;
        }

        if (!this.blob) {
            return '';
        }

        this._objectBlobUrl = await UrlHelpers.createObjectURLSmart(this.blob);
        
        return this._objectBlobUrl;
    }

    revokeObjectUrl() {
        if (this._objectBlobUrl) {
            UrlHelpers.revokeObjectURLSmart(this._objectBlobUrl)
            this._objectBlobUrl = undefined;
        }
    }

    /**
     * Cleans up all in-memory caches (blob URL and base64) without deleting the record.
     * Call this when switching projects or leaving the editor to free memory.
     */
    cleanMemory() {
        this.revokeObjectUrl();
    }
}